import React from 'react';
import styled from 'styled-components';
import { Draggable } from 'react-beautiful-dnd';

import EditorInput from '../EditorInput/Editor.Component';
import ImageInput from '../ImageInput/ImageInput.Component';
import VideoInput from '../VideoInput/VideoInput.Component';
import IconInput from '../IconInput/IconInput.Component';
import Handle from '../Handle/Handle.Component';
import AddHandle from '../AddHandle/AddHandle.Component';

const StyledRow = styled.div`
    display: flex:
    flex-direction: column;
    align-items: center;
    height: 300px;
    width: 100%;
    border: 2px solid rgba(255, 255, 255, .2);
    border-radius: 5px;
    margin-bottom: 48px;
`

const ContentWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    height: 240px;
    width: 100%;
`

const StyledColumn = styled.div`
    height: 240px;
    width: ${props => (Math.round(100 / props.columns))}%;
    // width: 30%;
    padding: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
`

const PlaceHolder = styled.div`
    width: 100%;
    height: 120px;
    border: 2px dotted rgba(255, 255, 255, .2);
    border-radius: 3px;
    margin-bottom: 8px;
`


class SingleRow extends React.Component {
    state = {
    }
    componentWillUpdate() {
        console.log("Single Row Will Update ...")
    }
    // add asset (for asset levels , not rows)
    addAsset = (type, level, colIdx) => {
        this.props.addAsset(type, level, colIdx, this.props.rowId);
    }

    deleteAsset = (colIdx) => {
        this.props.deleteAsset(colIdx, this.props.rowId);
    }

    deleteRow = () => {
        this.props.deleteRow(this.props.rowId);
    }

    selectMedia = (colIdx, value) => {
        this.props.editAsset(colIdx, this.props.rowId, value);
    }
    changeStyleProperty = (colIdx, property, value) => {
        this.props.changeStyleProperty(colIdx, property, value, this.props.rowId);
    }

    editText = (colIdx, value) => {
        this.props.editAsset(colIdx, this.props.rowId, value);
    }
    generateRowAssets = () => {
        return this.props.assets.map((asset, idx) => {
            return asset === null ? <StyledColumn key={`${this.props.rowId}-col-${idx}`} columns={this.props.assets.length}>
                <PlaceHolder />
                <AddHandle level='asset' clickAdd={this.addAsset} rowId={this.props.rowId} columnIndex={idx} />
            </StyledColumn> : <StyledColumn key={`${this.props.rowId}-col-${idx}`} columns={this.props.assets.length}>{this.generateCorrectAsset(asset, idx)}</StyledColumn>
        })
    }

    generateCorrectAsset = (asset, idx) => {
        if (asset.type === 'image') {
            return <ImageInput
                id={asset.id}
                columnIndex={idx}
                alignment={asset.align}
                size={asset.size}
                url={asset.content}
                selectImage={this.selectMedia}
                changeStyleProperty={this.changeStyleProperty}
                deleteAsset = {this.deleteAsset}
                type = {asset.type}
                // images = {this.props.images}
            />
        }
        else if (asset.type === 'video') {
            return <VideoInput
                id={asset.id}
                columnIndex={idx}
                alignment={asset.align}
                size={asset.size}
                url={asset.content}
                selectVideo={this.selectMedia}
                changeStyleProperty={this.changeStyleProperty}
                deleteAsset = {this.deleteAsset}
                // videos = {this.props.videos}
            />
        }else if (asset.type === 'text') {
            return <EditorInput
                id={asset.id}
                columnIndex={idx}
                alignment={asset.align}
                size={asset.size}
                text={asset.content}
                editText={this.editText}
                deleteAsset = {this.deleteAsset}
            />
        } else if (asset.type === 'icon') {
            return <ImageInput
                id={asset.id}
                columnIndex={idx}
                alignment={asset.align}
                size={asset.size}
                url={asset.content}
                selectImage={this.selectMedia}
                changeStyleProperty={this.changeStyleProperty}
                deleteAsset = {this.deleteAsset}
                type = {asset.type}
            />
        } else { return "_____________________" }
    }
    render() {
        return (
            <Draggable draggableId={this.props.rowId} index={this.props.index}>
                {provided => (
                    <StyledRow
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}>
                        <Handle type={this.props.rowId} deleteAsset = {this.deleteRow} />
                        <ContentWrapper>
                            {this.generateRowAssets()}
                        </ContentWrapper>
                    </StyledRow>
                )}
            </Draggable>
        )
    }
}

export default SingleRow;


// WEBPACK FOOTER //
// ./src/components/Admin/LessonBuilder/SIngleRow/SingleRow.Component.jsx